import { render, staticRenderFns } from "./AbbinaOrdInfoAzienda.vue?vue&type=template&id=04ffc210&"
import script from "./AbbinaOrdInfoAzienda.vue?vue&type=script&lang=js&"
export * from "./AbbinaOrdInfoAzienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports